import React, { useState, useRef } from "react";
import "./OtpPage.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { Spinner } from "@chakra-ui/react";
import axios from "axios";
import { baseUrl } from "../../../../../boot";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { setUser } from "../../../../redux/reduxSlice/SingIn&Singup/SingInSlice";
import { SingUp_ForgotPasswordOtpVerify,ForgotPasswordOtpSend } from "../../../../redux/reduxApi/SingIn&SingUp/ForgotpasswordAPI";

const OtpPage = () => {
  const [isLoading, setIsLoading] = useState(false);

  // Email OTP state and refs
  const [emailOtp, setEmailOtp] = useState(["", "", "", "", "", ""]);
  const emailInputRefs = useRef([]);

  const { email } = useParams(); // Removed phone param
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Email OTP handlers
  const handleEmailOtpChange = (index, e) => {
    const value = e.target.value;
    if (!/^[0-9]?$/.test(value)) return;

    const newOtp = [...emailOtp];
    newOtp[index] = value;

    setEmailOtp(newOtp);

    if (value && index < 5) {
      emailInputRefs.current[index + 1]?.focus();
    }
  };

  const handleEmailOtpKeyDown = (index, e) => {
    if (e.key === "Backspace" && !emailOtp[index] && index > 0) {
      emailInputRefs.current[index - 1]?.focus();
    }
  };

  // Combined submit handler for email OTP only
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    const payload = {
      email,
      otp: emailOtp.join(""),
    };

    try {
      const response = await dispatch(SingUp_ForgotPasswordOtpVerify(payload));
      console.log("OTP Verify",response);
      

      if (response?.payload?.success) {
        const { token, user } = response.payload;
        localStorage.setItem("authToken", token);
        localStorage.setItem("user", JSON.stringify(user));

        dispatch(setUser({ token, user }));

        toast.success("OTP verified successfully!");
        navigate("/login");
      } else {
        toast.error(response?.payload || "OTP verification failed");
      }
    } catch (error) {
      toast.error("Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };

  // Resend handler for email OTP only
  // const handleResend = () => {
  //   console.log("Resend OTP requested for email:", { email });
  //   toast.success("OTP resend requested (stub).");
  // };

  // Resend handler for email OTP only
const handleResend = async () => {
  try {
    if (!email) {
      toast.error("Email is required to resend OTP");
      return;
    }

    setIsLoading(true);
    
    const response = await dispatch(ForgotPasswordOtpSend({ email }));
    
    if (response?.payload?.data?.success) {
      toast.success(response.payload.data.message || "OTP resent successfully!");
      
      // Reset the OTP input fields
      setEmailOtp(["", "", "", "", "", ""]);
      
      // Focus on the first input field
      if (emailInputRefs.current[0]) {
        emailInputRefs.current[0].focus();
      }
    } else {
      toast.error(response?.payload?.data?.message || "Failed to resend OTP");
    }
  } catch (error) {
    console.error("Resend OTP error:", error);
    toast.error("Something went wrong while resending OTP");
  } finally {
    setIsLoading(false);
  }
};



  return (
    <div className="d-flex justify-content-center align-items-center pb-20 vh-100 bg-light overflow-hidden">
      {isLoading && (
        <div className="spinner-overlay">
          <Spinner size="xl" color="#661e33" />
        </div>
      )}
      <div className="bg-white p-5 rounded-3 shadow-sm border text-center w-30">
        <ShieldCheck color="#661e33" className="verification mx-auto" size={50}  />
        <p className="text-success" style={{ fontSize: "5.5rem" }}>
          <i className="fa-solid fa-envelope-circle-check"></i>
        </p>
        <p className="h5">Please Check Your Email/Mobile</p>
        <p className="text-muted">We've sent a code to {email}</p>
        <form onSubmit={handleSubmit}>
          <div className="d-flex justify-content-center gap-2 my-4">
            {emailOtp.map((digit, index) => (
              <input
                key={index}
                ref={(el) => (emailInputRefs.current[index] = el)}
                className="otp-letter-input text-center fs-4 border border-secondary rounded"
                type="text"
                maxLength={1}
                style={{ color: "#661e33" }}
                value={digit}
                onChange={(e) => handleEmailOtpChange(index, e)}
                onKeyDown={(e) => handleEmailOtpKeyDown(index, e)}
              />
            ))}
          </div>

          <div className="d-flex justify-content-center mt-4 gap-3">
             <button
              type="button"
              // className="btn btn-secondary px-4 py-2 border-0 rounded"
              className='border rounded-md py-2 px-3 font-semibold hover:bg-gray-200'
              onClick={handleResend}
            >
              Resend
            </button>
            <button
              type="submit"
              className="main-btn px-4"
            >
              Submit
            </button>
           
          </div>
        </form>
      </div>
    </div>
  );
};

export default OtpPage;
